import React, { Component } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import Route from './Route'
import Monitoring from '../Pages/Monitoring'
import Login from '../Pages/Login'
import { LogOut } from '../Pages/LogOut'
import Loginasuser from '../Pages/LoginAsUser'
import Tracks from '../Pages/Tracks'
import Timemachine from '../Pages/Timemachine'
import Units from '../Pages/Units'
import Groups from '../Pages/Groups'
import Geofences from '../Pages/Geofences'
import Reports from '../Pages/Reports'
import ReportsHistory from '../Pages/ReportsHistory'
import { ResetPassword } from '../Pages/ResetPassword'
import ValidateEmail  from '../Pages/ValidateEmail'
import Users from '../Pages/Users'
import Actionlogs from '../Pages/ActionLogs'
import InvoiceDetail from '../Pages/Invoices/Invoice'
import Invoice from '../Pages/Invoices/index'
import Messages from '../Pages/Messages'
import Drivers from '../Pages/Drivers'
import Trailer from '../Pages/Trailer'
import Trash from '../Pages/Trash'
import Dashboard from '../Pages/Dashboard/MainDashboardFile'
import MarkerMap from '../Pages/MarkerMap'
import Commands from '../Pages/Commands'
import Maintenance from '../Pages/Maintenance'
import Notification from '../Pages/Notifications'
import Events from '../Pages/Events'
import AccountManagements from '../Pages/AccountManagements'
import NotFound from '../Pages/NotFound'
import '../assets/main.scss'
import Vehicle from '../Pages/Vehicle'
import Garage from '../Pages/Garage'
import Area from '../Pages/AreaModule'
import Services from '../Pages/Services'
import Jobs from '../Pages/Jobs'
import Parameters from '../Pages/Parameters'
import BuildTheme from '../Pages/BuildTheme'
import DashboardBuilder from '../Pages/DashboardBuilder'
import PremiumDashboard from '../Pages/PremiumDashboard'
import WorkFlow from '../Pages/WorkFlow'
import Metrics from '../Pages/Metrics'
import UserLocationShare from '../Pages/UserLocationShare';
import MonitoringShareLocation from '../Pages/MonitoringShareLocation'
import DeliveryNote from '../Pages/DeliveryNote/index'
import DeliveryNotesView from '../Pages/DeliveryNote/DeliveryNotesView'

export default class Routes extends Component {
  checkBackToAdmin = () => {
    return localStorage.getItem('backtoAdmin');
  }
  render () {
    const backtoAdmin = this.checkBackToAdmin();
    return (
      <Switch>
     
  {
    backtoAdmin&&backtoAdmin!==""&&
    <Route
    path='/monitoringnew'
      {...this.props}
      render={routeProps => (
        <MonitoringShareLocation {...this.props} {...routeProps} {...this.state} />
      )}
    />
  }
         

        <Route
          exact
          {...this.props}
          path='/'
          render={
            routeProps => ( // eslint-disable-line no-unused-vars
              <Redirect to='/dashboard' />
            ) /*<Home {...routeProps} {...this.state} />*/
          }
        />
         <Route
          exact
          {...this.props}
          path='/metrics'
          render={routeProps => <Metrics {...routeProps} {...this.state} renderMode='default'/>}
        />
        <Route
          exact
          {...this.props}
          path='/workFlow'
          render={routeProps => <WorkFlow {...this.props} {...routeProps} {...this.state} renderMode='default'/>}
        />
          <Route
          exact
          {...this.props}
          path='/deliveryNote'
          render={routeProps => <DeliveryNote {...this.props} {...routeProps} {...this.state} renderMode='default'/>}
        />
                 <Route
          exact
          {...this.props}
           path='/delivery-detail'
          render={routeProps => <DeliveryNotesView {...this.props} {...routeProps} {...this.state} renderMode='default'/>}
        />
        <Route
          exact
          path='/dashboard'
          {...this.props}
          render={routeProps => <Dashboard {...routeProps} {...this.state} {...this.props}/>}
        />
        <Route
          {...this.props}
          exact
          path='/login'
          render={routeProps => (
            <Login {...this.props} {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/logout'
          render={routeProps => <LogOut {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/loginasuser'
          render={routeProps => <Loginasuser {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/locationshare'
          render={routeProps => <UserLocationShare {...this.props} {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/monitoring'
          render={routeProps => <Monitoring {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/tracks'
          render={routeProps => <Tracks {...this.props} {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/tracks/:id'
          render={routeProps => <Tracks {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/Dlogs'
          render={routeProps => <Messages {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/timemachine'
          render={routeProps => <Timemachine {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/units/:id'
          render={routeProps => <Units {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/units/add/unit'
          render={routeProps => (
            <Units {...routeProps} {...this.state} addUnitScreen={true} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/units'
          render={routeProps => <Units {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/users/:id'
          render={routeProps => <Users {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/commands'
          render={routeProps => <Commands {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/maintenance'
          render={routeProps => <Maintenance {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/maintenanceCreate'
          render={routeProps => <Maintenance {...routeProps} {...this.state} />}
        />
        <Route
          exact
          path='/maintenanceUpdate/:id'
          {...this.props}
          render={routeProps => (
            <Maintenance {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/parameters'
          render={routeProps => <Parameters {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/users'
          render={routeProps => <Users {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/addUser'
          render={routeProps => (
            <Users {...routeProps} {...this.state} addUserScreen={true} />
          )}
        />
        <Route
          {...this.props}
          exact
          path='/resources'
          render={routeProps => (
            <Groups {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/resources/:id'
          render={routeProps => (
            <Groups {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/themeBuilder'
          render={routeProps => (
            <BuildTheme {...routeProps} {...this.state} />
          )}
        />
        
        <Route
          exact
          {...this.props}
          path='/premium_dashboard/:id'
          render={routeProps => (
            <PremiumDashboard {...routeProps} {...this.state} />
          )}
        />
        
        <Route
          exact
          {...this.props}
          path='/dashboardBuilder'
          render={routeProps => (
            <DashboardBuilder {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/dashboardBuilder/:id'
          render={routeProps => (
            <DashboardBuilder {...routeProps} {...this.state} />
          )}
        />
       
        <Route
          {...this.props}
          exact
          path='/geofences'
          render={routeProps =><Geofences {...routeProps} {...this.state} />
        }
        />
        <Route
          exact
          {...this.props}
          path='/reports'
          render={routeProps => <Reports {...routeProps} {...this.state} />}
        />
        <Route
          {...this.props}
          exact
          path='/reportsHistory'
          render={routeProps => <ReportsHistory {...routeProps} {...this.state} />}
        />
        
        <Route
          {...this.props}
          exact
          path='/users'
          render={routeProps => <Users {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/drivers'
          render={routeProps => <Drivers {...routeProps} {...this.state} />}
        />
        <Route
          {...this.props}
          exact
          path='/drivers/:id'
          render={routeProps => <Drivers {...routeProps} {...this.state} />}
        />
        <Route
          {...this.props}
          exact
          path='/binders'
          render={routeProps => <Trailer {...routeProps} {...this.state} />}
        />
        <Route
          {...this.props}
          exact
          path='/binders/:id'
          render={routeProps => <Trailer {...routeProps} {...this.state} />}
        />
        
        
        <Route
          {...this.props}
          exact
          path='/notifications'
          render={routeProps => (
            <Notification {...routeProps} {...this.state} />
          )}
        />
        <Route
          {...this.props}
          exact
          path='/notificationCreate'
          render={routeProps => (
            <Notification {...routeProps} {...this.state} />
          )}
        />
        <Route
          {...this.props}
          exact
          path='/notificationUpdate/:id'
          render={routeProps => (
            <Notification {...routeProps} {...this.state} />
          )}
        />
        <Route
          {...this.props}
          exact
          path='/events'
          render={routeProps => <Events {...routeProps} {...this.state} />}
        />
        <Route
          {...this.props}
          exact
          path='/events/:id'
          render={routeProps => <Events {...routeProps} {...this.state} />}
        />
        <Route
          {...this.props}
          exact
          path='/maps/:lat/:lng'
          render={routeProps => <MarkerMap {...routeProps} {...this.state} />}
        />
        
        <Route
          exact
          {...this.props}
          path='/vehicles'
          render={routeProps => <Vehicle {...routeProps} {...this.state} renderMode='default'/>}
        />
        <Route
          exact
          {...this.props}
          path='/garage'
          render={routeProps => <Garage {...routeProps} {...this.state} renderMode='default'/>}
        />
        <Route
          exact
          {...this.props}
          path='/area'
          render={routeProps => <Area {...routeProps} {...this.state} renderMode='default'/>}
        />
         <Route
          exact
          {...this.props}
          path='/services'
          render={routeProps => <Services {...routeProps} {...this.state} renderMode='default'/>}
        />
        {/* <Route
          exact
          path='/services'
          render={routeProps => <Services {...routeProps} {...this.state} renderMode='default'/>}
        /> */}
        <Route
          exact
          {...this.props}
          path='/schedules'
          render={routeProps => <Jobs {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/schedules/:id'
          render={routeProps => <Jobs {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/vehicle/:id'
          render={routeProps => <Vehicle {...routeProps} {...this.state} renderMode='view'/>}
        />
        <Route
          exact
          {...this.props}
          path='/vehicles/:id'
          render={routeProps => <Vehicle {...routeProps} {...this.state} renderMode='edit'/>}
        />
        <Route
          exact
          {...this.props}
          path='/trash'
          render={routeProps => <Trash {...routeProps} {...this.state} />}
        />
        <Route
          exact
          {...this.props}
          path='/accountManagements'
          render={routeProps => (
            <AccountManagements {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/reset'
          render={routeProps => (
            <ResetPassword {...this.props} {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/verify/email'
          render={routeProps => (
            <ValidateEmail {...this.props} {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/actionlogs'
          render={routeProps => (
            <Actionlogs {...this.props} {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/invoiceDetail'
          render={routeProps => (
            <InvoiceDetail {...this.props} {...routeProps} {...this.state} />
          )}
        />
        <Route
          exact
          {...this.props}
          path='/invoice'
          render={routeProps => (
            <Invoice {...this.props} {...routeProps} {...this.state} />
          )}
        />
        
          {backtoAdmin&& backtoAdmin!==""?<Redirect to="/monitoringnew"/>:<Redirect to="/logout"/>}
        
        <Route path='*' component={NotFound} />
      </Switch>
    )
  }
}
